<template>
  <div>
    <el-button style="margin-bottom: 10px" type="primary" icon="el-icon-s-promotion"
      @click="openSendMailDialog()">发送邮件</el-button>
    <el-tabs v-model="activeTabName">
      <el-tab-pane label="邮件模板" name="mailTemplates">
        <MailTemplateList v-if="activeTabName == 'mailTemplates'"></MailTemplateList>
      </el-tab-pane>
      <el-tab-pane label="附件模板" name="propsTemplates">
        <PropsTemplateList v-if="activeTabName == 'propsTemplates'"></PropsTemplateList>
      </el-tab-pane>
      <el-tab-pane label="版本邮件" name="versionMails">
        <VersionMailList v-if="activeTabName == 'versionMails'"></VersionMailList>
      </el-tab-pane>
      <el-tab-pane label="定时邮件" name="scheduledMails">
        <ScheduledMailList v-if="activeTabName == 'scheduledMails'"></ScheduledMailList>
      </el-tab-pane>
      <el-tab-pane label="历史发送邮件" name="historySentMails">
        <HistorySentMails v-if="activeTabName == 'historySentMails'"></HistorySentMails>
      </el-tab-pane>
    </el-tabs>
    <!-- “添加邮件模板”对话框 -->
    <EditMailTemplateDialog v-if="shouldEditTemplateDialogVisible" @close="onEditMailTemplateDialogClosed()"
      :value="valueForEditMailTemplateDialog"></EditMailTemplateDialog>

    <!-- “发送邮件”对话框 -->
    <SendMailDialog v-if="shouldSendMailDialogVisible" @close="onSendMailDialogClosed()" :value="dataForSendMailDialog">
    </SendMailDialog>
  </div>
</template>

<script>

import EditMailTemplateDialog from "./EditMailTemplateDialog";
import SendMailDialog from "./SendMailDialog";
import MailTemplateList from "./tab-pages/MailTemplateList";
import PropsTemplateList from "./tab-pages/PropsTemplateList";
import ScheduledMailList from "./tab-pages/ScheduledMailList";
import HistorySentMails from "./tab-pages/HistorySentMails";
import VersionMailList from "./tab-pages/VersionMailList";

export default {
  data() {
    return {
      activeTabName: "",
      shouldEditTemplateDialogVisible: false, // “添加邮件模板”对话框是否应该显示出来
      shouldSendMailDialogVisible: false, // “发送邮件”对话框是否应该显示出来
      valueForEditMailTemplateDialog: null, // 要传递给“添加邮件模板”对话框的数据
      dataForSendMailDialog: null, // 要传递给“发送邮件”对话框的数据
    };
  },

  components: {
    EditMailTemplateDialog,
    SendMailDialog,
    MailTemplateList,
    ScheduledMailList,
    HistorySentMails,
    PropsTemplateList,
    VersionMailList,
  },

  async created() {
    let tabNameInUrl = this.$route.query["tab"];
    if (tabNameInUrl) {
      this.activeTabName = tabNameInUrl;
    } else {
      this.activeTabName = "mailTemplates";
    }
  },

  watch: {
    activeTabName(newValue, oldValue) {
      if (this.$route.query["tab"] != newValue) {
        let query = JSON.parse(JSON.stringify(this.$route.query))
        query["tab"] = newValue
        this.$router.replace({ path: this.$route.path, query: query })
      }
    },
  },

  methods: {
    /**
     * 打开“添加邮件模板”对话框
     */
    async openEditMailTemplateDialog(isCreate, templateData) {
      this.shouldEditTemplateDialogVisible = true;
      this.valueForEditMailTemplateDialog = {
        isCreate: isCreate,
        templateData: templateData,
      };
    },

    /**
     * “添加邮件模板”对话框关闭了
     */
    async onEditMailTemplateDialogClosed() {
      this.shouldEditTemplateDialogVisible = false;

      // 重新拉取邮件模板集合
      return this.loadMailTemplateList();
    },

    /**
     * 打开“发送邮件”对话框
     */
    async openSendMailDialog(templateData) {
      this.shouldSendMailDialogVisible = true;
      this.dataForSendMailDialog = {
        mailTemplate: templateData,
      };
    },

    /**
     * “发送邮件”对话框关闭了
     */
    async onSendMailDialogClosed() {
      this.shouldSendMailDialogVisible = false;
    },
  },
};
</script>